var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNbis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1552 1378",
    width: 1552,
    height: 1378,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#e0ff4f}.b{fill:#052b42}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1206.1 0h-862.8c-189.6 0-343.3 155.5-343.3 347.4v683.2c0 191.9 153.7 347.4 343.3 347.4h862.8c189.6 0 343.3-155.5 343.3-347.4v-683.2c0-191.9-153.7-347.4-343.3-347.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m622 363.7c60.9 0 103.8 33.7 130.1 93.8l160.6 371.3c40.7 93.9 117.5 83.2 117.5 83.2 0 52.9-41.5 102.4-102.5 102.4-60.9 0-103.8-33.8-130.1-93.9l-160.6-371.2c-40.6-93.8-117.4-83.3-117.4-83.3v539h-127.6v-384.4c0-146.4 126.9-154.5 127.6-154.6 0-52.9 41.6-102.3 102.4-102.3zm535.8 393.8c0 146.8-127.5 154.5-127.6 154.5v-538.9h127.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbis);
export default __webpack_public_path__ + "static/media/NBIS.e33d033afc30d80fca8644c74698d673.svg";
export { ForwardRef as ReactComponent };